import React, { useEffect } from "react";
// libs
import styled from "styled-components";
// components
import CustomHead from "src/components/ui/CustomHead";
import Layout from "src/layout";
import ReviewForm from "src/components/containers/leaveReview/index";
import Submitted from "src/components/containers/leaveReview/submitted/Submitted";
// hooks
import { useAppDispatch, useAppSelector } from "src/hooks";
import { useRouter } from "next/router";
import { useClinic } from "src/hooks/requests/clinics";
import { useDynamicCommonData } from "src/hooks/dynamic/common";
import useAllPage from "src/hooks/dynamic/allPage";
// redux
import { reviewSelector, setReviewStep, clearReviewState } from "src/redux/slices";
// theme
import { colors } from "src/theme/colors";
// types
import { EVariants } from "src/constants/variants";
import { GetServerSideProps, NextPage } from "next";

const Wrapper = styled.div`
  background-color: ${colors.white};
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

interface ILeaveReviewPage {}

const LeaveReviewPage: NextPage<ILeaveReviewPage> = () => {
  const router = useRouter();
  const dispatch = useAppDispatch();
  const { step, clinic: clinicRedux } = useAppSelector(reviewSelector);

  const clinicId: number = Number(router.query.clinic as string);
  const { clinic } = useClinic(clinicId, clinicRedux);

  useEffect(() => {
    return () => {
      // clear values on unmount
      dispatch(clearReviewState());
    };
  }, []);

  useEffect(() => {
    window?.scrollTo(0, 0);
  }, [step]);

  const GoNext = () => dispatch(setReviewStep(step + 1));

  const goToClinic = () => {
    let path = "/";
    if (clinic) {
      path = clinic?.slug.startsWith("/") ? `/clinics${clinic?.slug}` : `/clinics/${clinic?.slug}`;
    }
    router.push(path);
  };
  const btnName = clinic?.name && clinic?.name.length < 10 ? clinic.name : "clinic";

  return (
    <>
      <CustomHead />

      <Wrapper>
        <Layout headerProps={{ variant: EVariants.SECONDARY, styles: { width: "1096px" } }}>
          {step === 0 && (
            <ReviewForm
              GoNext={GoNext}
              // @ts-ignore
              clinicId={clinic?.id}
              clinicName={clinic?.name as string}
            />
          )}
          {step === 1 && <Submitted btnText={`Back to ${btnName}`} btnClick={goToClinic} />}
        </Layout>
      </Wrapper>
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const initialReduxState = await useAllPage(ctx.locale as string);

  return {
    props: {
      initialReduxState: { DYNAMIC: initialReduxState.DYNAMIC },
    },
  };
};

export default LeaveReviewPage;
